import * as React from 'react';

import { type SidebarContextProps } from '../components/Sidebar';

export const SidebarContext = React.createContext<SidebarContextProps | null>(
  null,
);

export function useSidebarContext() {
  const context = React.useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebarContext must be used within a SidebarProvider.');
  }

  return context;
}
